/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import slices from '../../state/slices/data';
import slicesThumb from '../../state/slices/thumbslider';

export default function Card(props) {
  // console.log(props);
  const { person, thumbPath, id, type } = props;

  const { setIndex } = slices.actions;
  const { requestScrollToView } = slicesThumb.actions;

  const dragging = useSelector((state) => state.thumbslider.dragging);
  const selectedIndex = useSelector((state) => state.data.curIndex);
  const dispatch = useDispatch();
  // console.log('props ', props);

  const cardRef = useRef();

  function onCardClick() {
    if (!dragging) {
      console.log('index ', id, selectedIndex);
      dispatch(setIndex(id));
    }
  }

  const style = {
    border: selectedIndex === id ? '4px solid #e12827' : '4px solid #efefef',
  };

  useEffect(() => {
    if (selectedIndex === id) {
      const bounds = cardRef.current.getBoundingClientRect();
      console.log('bounds ', bounds);
      if (bounds.x < 50 || bounds.x > window.innerWidth - 50) {
        dispatch(requestScrollToView(id));
      }
    }
  }, [selectedIndex]);

  return (
    <div
      ref={cardRef}
      className="card"
      style={style}
      onClick={() => onCardClick()}
    >
      <img
        className="card-image"
        src={thumbPath}
        width="100%"
        height="auto"
        alt={person}
      />
      <div className="year-text">{type}</div>
    </div>
  );
}
